import { PagedMultiSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { organizationalUnitService } from "../api/organizationalUnitService";

const fetchConfig = laravelServiceSelectFetchConfig(organizationalUnitService);

interface Props {
	name: string;
	label: string;
	required?: boolean;
}

export const OrganizationalUnitMultiSelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={fetchConfig} />;
};
